import { z } from 'zod';

import {
  ValidUuidOrNotSetSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodDeleteCompanyAliasAddressEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.literal('alias_address'),
  z.uuid(),
]);

export const zodDeleteCompanyAliasAddressSearchParamsSchema = z
  .object({ issuerId: ValidUuidOrNotSetSchema })
  .transform((data) =>
    withoutObjectKeysWhereValueIs(data, [null, undefined, '']),
  );
